module.exports = __webpack_public_path__ + "static/media/stand_2.8102d291.png";